import { render, staticRenderFns } from "./targets-table.vue?vue&type=template&id=5dec3177&scoped=true"
import script from "./targets-table.vue?vue&type=script&lang=js"
export * from "./targets-table.vue?vue&type=script&lang=js"
import style0 from "./targets-table.vue?vue&type=style&index=0&id=5dec3177&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec3177",
  null
  
)

export default component.exports